import React, {memo, type ReactNode, type HTMLAttributes} from 'react';
import classNames from 'classnames';
import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import styles from './styles.module.css';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum BADGE_SIZE {
    MEDIUM = 'medium',
    SMALL = 'small',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum BADGE_VARIANT {
    DEFAULT = 'default',
    HIGHLIGHT = 'highlight',
    ATTENTION = 'attention',

}

type Props = {
    show?: boolean;
    size?: BADGE_SIZE;
    variant?: BADGE_VARIANT;
    wrapperClass?: string;
    children: ReactNode;
};

type Attrs = HTMLAttributes<HTMLElement>

export const Badge = memo(({
    show = true,
    variant = BADGE_VARIANT.DEFAULT,
    size = BADGE_SIZE.MEDIUM,
    wrapperClass,
    children,
    ...attrs
}: Props & Attrs) => {
    const [badgeMediumTypography, badgeSmallTypography] = useTypography([
        {size: TypographySize.BodyXSTrue},
        {size: TypographySize.BodyXSSTrue},
    ]);
    const badgeSizeTypography = size === BADGE_SIZE.MEDIUM ? badgeMediumTypography : badgeSmallTypography;
    const ButtonOrDiv: keyof JSX.IntrinsicElements = attrs.onClick ? 'button' : 'div';

    if (!show) {
        return null;
    }

    return (
        <div className={classNames(styles.badge, 'Badge', wrapperClass)}>
            <ButtonOrDiv
                {...attrs}
                className={classNames(
                    styles.badgeBox,
                    styles[size],
                    styles[variant],
                    badgeSizeTypography,
                    attrs.className,
                    'Badge__box',
                )}
            >
                {children}
            </ButtonOrDiv>
        </div>
    );
});
